<template>
    <div>
        <slot v-if="!hidden" name="activator" :on-click="initCollectionDownload">
            <v-btn @click="initCollectionDownload">Download</v-btn>
        </slot>

        <v-dialog v-model="showProgress" max-width="400px">
            <v-card>
                <v-card-title>Downloading..</v-card-title>
                <v-card-text>
                    <div>
                        <v-progress-linear
                            :color="overallProgress === 100 ? 'success' : 'primary'"
                            rounded
                            dark
                            v-model="overallProgress"
                            height="20"
                        >
                            {{ overallProgress }}%
                        </v-progress-linear>
                    </div>
                </v-card-text>
                <v-card-actions class="d-flex justify-center">
                    <v-btn depressed @click="cancelDownload" color="error"> Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import JSZip from 'jszip';
import { mapActions } from 'vuex';
import TributePhotoService from '@/services/tributePhoto.service';
export default {
    data() {
        return {
            downloadProgress: {},
            overallProgress: 0,
            showProgress: false,
            photoApi: null,
            downloadCancelToken: null,
        };
    },
    props: {
        tributeVideoId: {
            type: Number,
            required: true,
        },
        zipLabel: {
            type: String,
            required: true,
        },
        hidden: {
            type: Boolean,
            default: false,
        },
    },
    inject: ['state'],
    methods: {
        ...mapActions(['showSnackbar']),
        resetDownloadState() {
            this.downloadProgress = {};
            this.overallProgress = 0;
            this.showProgress = false;
        },
        async initCollectionDownload() {
            try {
                this.downloadCancelToken = this.axios.CancelToken;

                const source = this.downloadCancelToken.source();

                this.downloadCancelToken = source;

                // const photos = await this.getCollection(this.tributeVideoId);
                const { data: photos } = await this.photoApi.getCollectionUrls(this.tributeVideoId, {
                    cancelToken: source.token,
                });

                await this.downloadImages(photos);
            } catch (error) {
                console.log(error, 'error downloading album');
            } finally {
                this.resetDownloadState();
            }
        },
        async downloadImages(photos) {
            try {
                this.loading = true;
                this.showProgress = true;

                const promises = photos.map(async image => {
                    const blob = await this.getImageData(image);

                    return { ...image, blob: blob };
                });

                const res = await Promise.all(promises);

                //Download multiple as zip folder
                if (photos.length > 1) {
                    const zip = new JSZip();

                    res.forEach((image, index) => {
                        zip.file(image.name, image.blob);
                    });

                    const zipFile = await zip.generateAsync({ type: 'blob' });

                    this.downloadBlob(zipFile, this.zipLabel);
                    this.showSnackbar({ message: 'Photos downloaded' });
                } else {
                    this.downloadBlob(res[0].blob, res[0].name);
                    this.showSnackbar({ message: 'Photo downloaded' });
                }

                // this.loading = false;
            } catch (error) {
                console.log(error, 'zip error');
                let message;
                if (error.message === 'Cancelled by user') {
                    message = error.message;
                } else {
                    message = 'Error downloading images';
                }
                this.showSnackbar({ message, color: 'error' });
            }

            this.showProgress = false;
        },
        getImageData(photo, onProgressUpdate) {
            return new Promise((resolve, reject) => {
                this.loading = true;
                this.downloadProgress[photo.id] = 0;

                const cancelToken = this.downloadCancelToken?.token;

                this.axios({
                    method: 'get',
                    url: photo.url,
                    responseType: 'blob',
                    cancelToken: cancelToken,
                    onDownloadProgress: evt => {
                        const { loaded, total } = evt;
                        this.downloadProgress[photo.id] = Math.round((loaded / total) * 100);
                        this.calculateOverallProgress();
                    },
                })
                    // .then(resp => resp.blob())
                    .then(resp => {
                        resolve(resp.data);
                    })
                    .catch(error => {
                        console.log(error, 'error');
                        this.loading = false;
                        reject(error);
                    });
            });
        },
        downloadBlob(file, name) {
            const blob = window.URL.createObjectURL(file);
            const anchor = document.createElement('a');

            anchor.style.display = 'none';
            anchor.href = blob;
            anchor.download = name;
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            window.URL.revokeObjectURL(blob);
        },
        calculateOverallProgress() {
            const allProgress = Object.values(this.downloadProgress);
            const totalProgress = allProgress.reduce((acc, progress) => acc + progress, 0);
            this.overallProgress = Math.round(totalProgress / Object.keys(this.downloadProgress).length);
        },
        cancelDownload() {
            if (this.downloadCancelToken) {
                this.downloadCancelToken.cancel('Cancelled by user');
            }
        },
        async setAuthToken() {
            if (this.state.token) {
                this.token = this.state.token;
            } else {
                const response = await this.$auth.getIdTokenClaims();
                this.token = response.__raw;
            }
        },
    },
    async mounted() {
        await this.setAuthToken();

        this.photoApi = TributePhotoService(this.token);
    },
};
</script>
<style lang=""></style>
